<script setup lang="ts">

import {useBreadcrumb} from "@/composables/breadcrumb";
import {useAuth} from "@/composables/auth";
import axios from "axios";
import {route} from "ziggy-js";
import {useDisplay} from "vuetify/framework";

const { breadcrumbs } = useBreadcrumb();

const {user} = useAuth()

const {mdAndUp} = useDisplay()

const show = defineModel<boolean>();

const logout = () => {
    axios.post(route('logout')).then(() => {
        window.location.href = '/login'
    })
}

const goToDocumentation = () => {
    window.open('https://clinbiokb.sib.swiss/s/capacity-framework', '_blank')
}
</script>

<template>
    <v-app-bar
        :flat="true"
        density="compact"
        scroll-behavior="fully-hide"
        color="#10161D"
        theme="customDarkTheme"
        border="b-sm"
    >
        <template #prepend>
            <div class="text-body-2 font-weight-bold align-center">
                <v-btn
                    :icon="true"
                    :flat="true"
                    size="32"
                    class="rounded"
                    color="base"
                    @click="show = !show"
                >
                    <v-icon size="20">
                        mdi-menu
                    </v-icon>
                </v-btn>
            </div>
        </template>
        <template #append>
            <v-icon-btn
                icon="mdi-help"
                icon-size="18"
                size="28"
                border="sm"
                class="mr-1"
                @click="goToDocumentation"
            />
            <v-menu
                location="bottom start"
                width="200"
                theme="customLightTheme"
            >
                <template #activator="{ props: bind }">
                    <v-btn
                        color="base"
                        class="px-3"
                        rounded
                        v-bind="bind"
                    >
                        {{ user.name }}
                        <v-icon
                            size="28"
                            class="ml-2"
                        >
                            mdi-account-circle
                        </v-icon>
                    </v-btn>
                </template>
                <v-list
                    border="sm"
                    class="pa-0"
                    nav
                    rounded="lg"
                    elevation="3"
                >
                    <v-list-item
                        density="compact"
                        class="ma-1"
                        link
                        @click="logout"
                    >
                        <v-list-item-title class="text-body-2 font-weight-regular">
                            Sign out
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </template>
    </v-app-bar>
</template>

<style scoped>
</style>
